import React from 'react';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import PlacesAutocomplete from 'react-places-autocomplete';
import ImageComponent from 'atoms/Image';
import SEARCH_STORE_CONSTANTS from 'organisms/SearchStore/AU/Constants/SearchStoreConstants';
import { getValueOrDefaultAlternativeObject, getAndCheck, getTernaryValue, getLength } from 'common/utilities/utils';
import { IMAGE_PATH } from 'common/ImageConstants/ImagePathUtils';
import { getSortedSuggesstion } from './DispositionModuleUtils/DispositionModuleUtils';

const { GoogleMapLocationImage, SuggestionItemSearchPin, clearTextIcon, Time_Clock } = IMAGE_PATH;
const {
  SUUGESTED_ITEMS_TEXT,
  ALLOWED_SUGGESTION_LIST: allowedSuggestionList,
  SUGGESTION_ACTIVE_COLOR: suggestionHighLightColor,
  SUGGESTION_ACTIVE_OPACITY: suggestionOpacity,
  BRAND_BLACK: brandBlack,
} = SEARCH_STORE_CONSTANTS;

const SearchAddressFormComp = props => {
  const {
    currentMarket,
    placeholder,
    storeSelection = {},
    address,
    inputOnChange,
    handleSelectAddress,
    onSearchError,
    locationAlert,
    negativeScenarioAlert,
    inputRef,
    keyPress,
    onClearTextHandler,
    showAutoSuggestion,
    alreadySearched,
    setSuggestedAddress,
    filteredTypes,
  } = props;
  const { placesSearchInput = true } = storeSelection;

  return (
    <div className='search-delivery-address'>
      <div className='input-delivery-address'>
        <PlacesAutocomplete
          value={address}
          onChange={inputOnChange}
          onSelect={handleSelectAddress}
          searchOptions={{
            componentRestrictions: { country: currentMarket },
            types: filteredTypes,
          }}
          shouldFetchSuggestions={true}
          onError={onSearchError}
        >
          {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
            <div>
              {placesSearchInput && (
                <>
                  <ImageComponent
                    data-testid=''
                    srcFile={GoogleMapLocationImage}
                    alt=' '
                    className='google-location-img'
                  />
                  <input
                    data-testid='store-search-input'
                    aria-label='Enter your delivery address'
                    className={`${getTernaryValue(
                      getValueOrDefaultAlternativeObject(locationAlert, negativeScenarioAlert),
                      'store-search-input error-border mt-2',
                      'store-search-input mt-2',
                    )}`}
                    {...getInputProps({
                      placeholder: placeholder,
                      ref: inputRef,
                    })}
                    onKeyUp={keyPress}
                  />
                  {address && (
                    <img
                      src={clearTextIcon}
                      alt='clear-text-btn'
                      data-testid='clear-text-btn'
                      className='clearTextIcon'
                      onClick={onClearTextHandler}
                    />
                  )}
                  {getAndCheck(getLength(suggestions), showAutoSuggestion) ? (
                    <div className='suggestion-list'>
                      {getSortedSuggesstion(suggestions).map((suggestion, index) => {
                        // comment purpose: earlier filteration was done from UI side & now we filter by using placesAutocomplete attributes
                        //if (suggestion?.types?.some(itemType => allowedSuggestionList.includes(itemType))) {
                        setSuggestedAddress?.(suggestions);

                        return (
                          <React.Fragment key={suggestion?.id}>
                            {index === 0 && (
                              <div className='suggestion-items suggest-text'>
                                {translateWithI18Next(SUUGESTED_ITEMS_TEXT)}
                              </div>
                            )}
                            <div className='suggestion-item-container'>
                              <div
                                key={index}
                                {...getSuggestionItemProps(suggestion, {
                                  className: 'suggestion-items',
                                })}
                              >
                                <div className='suggested-address-alignment-delivery'>
                                  <div>
                                    <ImageComponent
                                      data-testid=''
                                      srcFile={getTernaryValue(
                                        alreadySearched(suggestion.description),
                                        Time_Clock,
                                        SuggestionItemSearchPin,
                                      )}
                                      alt={'googleMapLocation'}
                                      className='suggetion-pin'
                                    />
                                  </div>
                                  <div className='suggestion-description'>{suggestion.description}</div>
                                </div>
                              </div>
                            </div>
                          </React.Fragment>
                        );
                      })}
                    </div>
                  ) : null}
                </>
              )}
            </div>
          )}
        </PlacesAutocomplete>
      </div>
    </div>
  );
};

export const SearchAddressForm = React.memo(SearchAddressFormComp);
